var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fc2f34d8fc304410c8ce7ada21f2db7ee8aca923"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["poryadok-ru@sentry"]={id:"fc2f34d8fc304410c8ce7ada21f2db7ee8aca923"};
      